export const DocLink = {
  HOME: 'https://www.ezboti.com/docs/revenue/',
  API: 'https://www.ezboti.com/docs/revenue/api/',
  CONTACT: 'https://www.ezboti.com/contact/',
  BALANCE_TASK: 'https://www.ezboti.com/docs/revenue/balance-task/',
  NOTIFIER: 'https://www.ezboti.com/docs/revenue/notifier/',
}
